import { render } from "./Marshalls.vue?vue&type=template&id=204c8a48&scoped=true"
import script from "./Marshalls.vue?vue&type=script&lang=js"
export * from "./Marshalls.vue?vue&type=script&lang=js"

import "./Marshalls.vue?vue&type=style&index=0&id=204c8a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204c8a48"]])

export default __exports__